import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Typography, Box, CircularProgress, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Checkbox } from "@mui/material";
import axios from "axios";
import { API_BASE } from "../../utils/api"; 
import {Grid, Card, CardContent,FormControlLabel,Button} from '@mui/material';
import { useNavigate } from "react-router-dom";
import IconButton from '@mui/material/IconButton';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';



const OrderDetailPage = () => {
  const { id } = useParams();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [hideDeliveredBtn, setHideDeliveredBtn] = useState(false);
  const [hideUnavailableBtn, setHideUnavailableBtn] = useState(false);
  const [selectedProducts, setSelectedProducts] = useState([]);
const navigate = useNavigate();

  
 

    useEffect(() => {
    const fetchOrderDetails = async () => {
      try {
        const response = await axios.get(`${API_BASE}/api/orders/table/${id}`);
        setOrder(response.data);
      } catch (err) {
        setError("Failed to fetch order details");
      } finally {
        setLoading(false);
      }
    };

    fetchOrderDetails();
  }, [id]);

 const handleMarkReady = async (product) => {
  try {
    await axios.put(`${API_BASE}/api/orders/${order._id}/product/${product.productId}/ready`);

    setOrder((prevOrder) => {
      const updatedProducts = prevOrder.products.map((p) =>
        p.productId === product.productId
          ? {
              ...p,
              status: "readyToDeliver",
              processingTime: p.processingTime || new Date().toISOString()
            }
          : p
      );
      return { ...prevOrder, products: updatedProducts };
    });
  } catch (error) {
    console.error("Error marking product as ready to deliver:", error);
  }
};

  const handleCheckboxChange = async (product) => {
  if (selectedProducts.includes(product.productId)) return;

  try {
    await axios.put(`${API_BASE}/api/orders/${order._id}/product/${product.productId}/deliver`);
    
    setOrder((prevOrder) => {
      const updatedProducts = prevOrder.products.map((p) =>
        p.productId === product.productId
          ? {
              ...p,
              status: "delivered",
              deliveredTime: new Date().toISOString(),
              processingTime: p.processingTime || new Date().toISOString()
            }
          : p
      );
      return { ...prevOrder, products: updatedProducts };
    });

    setSelectedProducts((prev) => [...prev, product.productId]);
  } catch (error) {
    console.error("Error updating product delivery:", error);
    setHideDeliveredBtn(true);
  }
};


  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "100vh" }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ textAlign: "center", color: "red", mt: 4 }}>
        <Typography variant="h6">{error}</Typography>
      </Box>
    );
  }

  if (!order) {
    return (
      <Box sx={{ textAlign: "center", mt: 4 }}>
        <Typography variant="h6">Order not found</Typography>
      </Box>
    );
  }
const handleMarkAsUnavailable = async (product) => {
  

  try {
    await axios.put(`${API_BASE}/api/orders/${order._id}/product/${product.productId}/unavailable`);

    setOrder((prevOrder) => {
      const updatedProducts = prevOrder.products.map((p) =>
        p.productId === product.productId
          ? { ...p, status: "unavailable" }
          : p
      );
      return { ...prevOrder, products: updatedProducts };
    });
  } catch (error) {
    console.error("Error marking product as unavailable:", error);
    setHideUnavailableBtn(true);
  }
};

  return (
    
  <Box sx={{ padding: 2 }}>
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
    <IconButton
      onClick={() => navigate('/dining')}
      className="back-button"
      style={{
        backgroundColor: '#e0e0e0',
        border: '1px solid #ccc',
        borderRadius: '50%',
        padding: '5px',
        color: '#333',
      }}
    >
      <KeyboardBackspaceIcon fontSize="medium" />
    </IconButton>
    <Typography variant="h4">
      Order Details
    </Typography>
  </Box>

<Box sx={{ padding: 2, maxWidth: 600, marginLeft: 0 }}>
  <Card elevation={6} sx={{ padding: 2 }}>
    <CardContent>
      <Grid container spacing={1}>
        <Grid item xs={12} sm={6}>
          <Typography variant="subtitle2" color="textSecondary">Order ID</Typography>
          <Typography variant="body1"><strong>{order.orderId}</strong></Typography>
        </Grid>

        <Grid item xs={12} sm={6}>
          <Typography variant="subtitle2" color="textSecondary">Table Number</Typography>
          <Typography variant="body1"><strong>{order.tableNumber}</strong></Typography>
        </Grid>

        <Grid item xs={12} sm={6}>
          <Typography variant="subtitle2" color="textSecondary">Customer Name</Typography>
          <Typography variant="body1"><strong>{order.name}</strong></Typography>
        </Grid>

        <Grid item xs={12} sm={6}>
          <Typography variant="subtitle2" color="textSecondary">Phone Number</Typography>
          <Typography variant="body1"><strong>{order.phoneNumber}</strong></Typography>
         
        </Grid>
      </Grid>
    </CardContent>
  </Card>
</Box>


    <Typography variant="h6" gutterBottom>
      Ordered Products
    </Typography>
<Box sx={{ maxHeight: 380, overflowY: 'auto', pr: 1 ,height: '100%',}}>
  <Grid container spacing={2}>
    {order.products.map((product) => (
  <Grid item xs={12} sm={6} md={4} key={product._id}>
    <Card elevation={3}
    sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          {product.productTitle.split(",")[0]}
        </Typography>
        <Typography variant="body2">
          Quantity: <strong>{product.quantity}</strong>
        </Typography>

        {product.status === "processing" && (
          <Button
            variant="outlined"
            color="info"
            fullWidth
            onClick={() => handleMarkReady(product)}
            sx={{ mb: 1 }}
          >
            Ready to Deliver
          </Button>
        )}

     
        {product.status === "readyToDeliver" && (
          <Button
            variant="contained"
            color="success"
            fullWidth
            onClick={() => handleCheckboxChange(product)}
            sx={{ mb: 1 }}
          >
            Delivered
          </Button>
        )}

        
        {["processing", "readyToDeliver"].includes(product.status) && (
          <Button
            variant="outlined"
            color="error"
            fullWidth
            onClick={() => handleMarkAsUnavailable(product)}
            sx={{ mb: 1 }}
          >
            Unavailable
          </Button>
        )}

        <p>Status: {product.status}</p>
<p>Processing Time: {product.processingTime && new Date(product.processingTime).toLocaleString()}</p>

{product.readyForDeliveryTime && (
  <p>Ready to Deliver : {new Date(product.readyForDeliveryTime).toLocaleString()}</p>
)}

{product.deliveredTime && (
  <p>Delivered Time: {new Date(product.deliveredTime).toLocaleString()}</p>
)}

      </CardContent>
    </Card>
  </Grid>
))}

  </Grid>
</Box>
</Box>
);

};

export default OrderDetailPage;



   
      